/*
 * Copyright (c) 2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import RowDataTable from "./RowDataTable.jsx";
import DisplayIcon from "./Icons/DisplayIcon.jsx";
import IconButtonComponent from "./BasicInputs/IconButtonComponent.jsx";
import EmptyStateBig from "./EmptyState/EmptyStateBig.jsx";
import TextElement from "./TextElement.jsx";
import OutputListItem from "./OutputList/OutputListItem.jsx";
import OutputList from "./OutputList/OutputList.jsx";
import InlineDialog from "./InlineDialog.jsx";
import DateTime from "toolbox/dateTime";
import BuildSessions from "../Objects/BuildSessions.jsx";

class BuildSessionsManagement extends Component {
    constructor() {
        super();
        this.state = {
            allBuildSessions: [],
            isLoadedComplete: false,
            selectedBuildSession: null
        }
    }


    async fetchData() {
        let allBuildSessions = await BuildSessions().listAll()
        console.log(allBuildSessions);
        this.setState({allBuildSessions: allBuildSessions ?? [], isLoadedComplete: true})
    }

    componentDidMount() {
        this.fetchData()
    }


    async handleClose() {
        let {selectedBuildSession} = this.state
        await BuildSessions(selectedBuildSession.indexKey).closeSession()
        await this.fetchData()
        this.setState({selectedBuildSession: null})
    }

    render() {
        let {allBuildSessions, selectedBuildSession} = this.state
        return (
            <div>
                <RowDataTable
                    selectedIndex={this.state.selectedIndex}
                    iconElement={(row) => {
                        return (<div
                            className={`flex-shrink-0  p-1 flex justify-center items-center rounded  border mr-3 `}>
                            <DisplayIcon iconName={"BuildSession"} size={"1.1rem"}/>
                        </div>)
                    }}
                    buttons={(row) => {
                        return <>
                            <IconButtonComponent text={`Close Session`}
                                                 iconName={"IoCloseCircleOutline"}
                                                 onClick={async () => {
                                                     await BuildSessions(row.indexKey).closeSession()
                                                     await this.fetchData()
                                                 }}/>
                        </>

                    }}
                    data={allBuildSessions.map(item => ({
                        ...item,
                        Name: item.indexKey,
                        Description: item.buildServerId

                    }))}
                    emptyState={() => {
                        return (<><EmptyStateBig iconName={"IoIosSearch"}
                                                 text={<div className={"w-96 space-y-3"}>
                                                     <TextElement
                                                         textType={"header-lg"}> No build sessions found</TextElement>
                                                 </div>}/></>)

                    }}
                    progressPending={!this.state.isLoadedComplete}
                    onRowClicked={(data) => {
                        this.setState({selectedBuildSession: data})
                    }}
                    onMiddleMouseClick={(data) => {
                    }}
                />

                <InlineDialog
                    title={"Build Session"}
                    isOpen={selectedBuildSession !== null}
                    button={[{
                        type: "delete", text: "Close Session", onClick: async () => {
                            await this.handleClose()
                        }
                    }, {
                        type: "abort",
                        text: "Abbrechen",
                        onClick: async () => {
                            this.setState({selectedBuildSession: null})
                        }
                    }]}
                    onClose={() => {
                        this.setState({selectedBuildSession: null})
                    }}>
                    <OutputList>
                        <OutputListItem titel={"Session Id"}>
                            <span>{selectedBuildSession?.indexKey}</span>
                        </OutputListItem>
                        <OutputListItem titel={"Build Server Id"}>
                            <span>{selectedBuildSession?.buildServerId}</span>
                        </OutputListItem>
                        <OutputListItem titel={"Builder URL"}>
                            <span>{selectedBuildSession?.builderURL}</span>
                        </OutputListItem>
                        <OutputListItem titel={"Start Time"}>
                            <span>{DateTime.format(selectedBuildSession?.startTime, "HH:mm dd.MM.yyyy")}</span>
                        </OutputListItem>
                    </OutputList>
                </InlineDialog>

            </div>
        );
    }
}

export default BuildSessionsManagement;